import Vue from "vue";
import VueRouter from "vue-router";
import CardEditView from "./views/CardEditView.vue";
import CardsView from "./views/CardsView.vue";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import NotFound from "./views/NotFound.vue";
import ProductEdit from "./views/ProductEdit.vue";
import SalesPointEdit from "./views/SalesPointEdit.vue";
import SalesPoints from "./views/SalesPoints.vue";
import UserEdit from "./views/UserEdit.vue";
//import UserHome from "./views/UserHome.vue";
import UserProductsList from "./views/UserProductsList.vue";
import Users from "./views/Users.vue";

Vue.use(VueRouter);

export default new VueRouter({
  mode: "history",
  base: __dirname,
  routes: [{
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import( /* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/users",
      name: "users",
      component: Users
    },
    {
      path: "/user/:id?",
      name: "user",
      component: UserEdit,
      /*
        children: [{
            path: "",
            name: "user-home",
            component: UserEdit
          },
          {
            path: "products",
            name: "user-products",
            component: UserProductsList
          }
        ]
        */
    },
    {
      path: "/user/:id/products",
      name: "user-products",
      component: UserProductsList
    },
    {
      path: "/user/:user_id/product/:product_id?",
      name: "user-product",
      component: ProductEdit
    },
    {
      path: "/sales-points",
      name: "sales-points",
      component: SalesPoints
    },
    {
      path: "/sales-point/:id?",
      name: "sales-point",
      component: SalesPointEdit
    },
    {
      path: "/cards/:page_id?",
      name: "cards",
      component: CardsView
    },
    {
      path: "/user/:user_id/cards/",
      name: "user-cards",
      component: CardsView
    },
    {
      path: "/card/:tipology/:id?",
      name: "card",
      component: CardEditView
    },
    {
      path: "/not-found",
      component: NotFound
    },
    {
      path: "*",
      redirect: "/not-found"
    }
  ]
});